import React from "react";
import "./About.css";
function About() {
  return (
    <div
      className="about_main_container"
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "row",
        // marginTop: "30px",
      }}
    >
      <div
        className="left"
        style={{
          display: "flex",
          flex: 0.6,
          flexDirection: "column",
          marginLeft: "40px",
          fontFamily: "serif",
          fontSize: "25px",
          justifyContent: "center",
          textAlign: "start",
          paddingLeft: "40px",
        }}
      >
        <h2 style={{ color: "whitesmoke" }}>
          We envision a India “where every woman and every girl, who wants to
          earn, gets the opportunities to do so.”
        </h2>
        <p
          style={{
            fontFamily: "serif",
            marginTop: "20px",
            fontSize: "20px",
            color: "whitesmoke",
          }}
        >
          For the thousands of stifled in low-income communities across the
          country, Srujna is the key to unlocking their power! Srujna touches
          their lives, by transforming the many groups that work with grassroots
          women – helping create powerful, enterprising women that produce and
          sell hand-made products. Together, they provide livelihood
          opportunities to these low-income women – empowering them to become
          role models and changemakers in their families and communities.
        </p>
      </div>

      <div
        className="rignt"
        style={{ display: "flex", flexDirection: "column", flex: 0.4 }}
      >
        <img
          style={{ display: "flex", flexDirection: "row" }}
          className="image_first"
          src={require("../../assets/images/work2.png")}
          alt=""
        />

        {/* <img
          className="image_seond"
          src={require("../../assets/images/work2.png")}
          alt=""
        /> */}
        <img
          style={{ display: "flex", flexDirection: "row" }}
          className="image_second"
          src={require("../../assets/images/work.png")}
          alt=""
        />
      </div>
    </div>
  );
}

export default About;
